module.exports = __webpack_public_path__ + "e6e27ae976f201156b3436ccb02ef600.pdf";